import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { GetStartedFAQ } from './GetStartedFAQ';
import { Rocket, ArrowRight } from 'lucide-react';
import { GlowingBorder } from '../ui/GlowingBorder';

export function GetStarted() {
  const { t } = useLanguage();

  return (
    <section id="get-started" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('getstarted.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('getstarted.description')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
            {t('getstarted.faq')}
          </h3>
          <GetStartedFAQ />
        </div>

        {/* New Optimization Section */}
        <div className="max-w-4xl mx-auto my-20">
          <GlowingBorder className="bg-gradient-to-r from-surface-dark to-primary/10 p-8 rounded-2xl text-center">
            <div className="flex justify-center mb-6">
              <Rocket className="h-12 w-12 text-primary animate-pulse" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">
              {t('getstarted.optimize')}
            </h3>
            <p className="text-lg text-blue-100 mb-6">
              {t('getstarted.question')}
            </p>
            <p className="text-lg text-blue-100 mb-6">
              {t('getstarted.body1')}
            </p>
            <p className="text-lg text-blue-100 mb-8">
              {t('getstarted.body2')}
            </p>
            <a 
              href="https://forms.fillout.com/t/ngyrjeNMHuus"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105"
            >
              {t('getstarted.cta')}
              <ArrowRight className="h-5 w-5" />
            </a>
          </GlowingBorder>
        </div>
      </div>
    </section>
  );
}